import('./pb-header--compose-v2.css');

const pbHeaderComposeV2 = {
    init: function() {
        $(".pb-header--compose-v2").find(".jsShow").on("click", function(e) {
            $(this).closest(".pb-header--compose-v2").addClass("show");
            return false;
        });
        $(".pb-header--compose-v2").find(".jsHide").on("click", function(e) {
            $(this).closest(".pb-header--compose-v2").removeClass("show");
            return false;
        });
    }
};
// initialize component
window.loadedComponents.push({ component: "pb-header--compose-v2", init: pbHeaderComposeV2.init });

export default() => {
    pbHeaderComposeV2.init();
}